import { render, staticRenderFns } from "./PresetsMenu.vue?vue&type=template&id=5ccd1044"
import script from "./PresetsMenu.vue?vue&type=script&lang=js"
export * from "./PresetsMenu.vue?vue&type=script&lang=js"
import style0 from "./PresetsMenu.vue?vue&type=style&index=0&id=5ccd1044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports